import { useLocation } from "@tanstack/react-router";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { useTranslate } from "@tolgee/react";
import { Button } from "#/components/ui/button";
import { LanguageSwitcher } from "#/components/locale/language-switcher";
import { LocalizedLink } from "#/components/locale/localized-link";
import {
	Sheet,
	SheetClose,
	SheetContent,
	SheetDescription,
	SheetTitle,
	SheetTrigger,
} from "#/components/ui/sheet";
import ThemeToggle from "#/components/ThemeToggle";
import { TenbaggerLogo } from "#/components/ui/logo.tsx";
import { NAV_LINKS } from "./nav-links";

const menuItemClass =
	"rounded-md px-3 py-2.5 text-body2-bold text-muted-foreground hover:bg-muted hover:text-foreground";
const menuItemActiveClass =
	"rounded-md px-3 py-2.5 text-body2-bold bg-muted !text-foreground";

export function MobileMenu() {
	const { t } = useTranslate();
	const [open, setOpen] = useState(false);
	const { pathname } = useLocation();
	const isTradeActive = pathname.startsWith("/trade/");

	return (
		<Sheet open={open} onOpenChange={setOpen}>
			<SheetTrigger asChild>
				<Button
					variant="ghost"
					size="icon-sm"
					className="text-muted-foreground hover:text-foreground md:hidden"
					aria-label={t("mobile-menu.open")}
				>
					<Menu className="h-4 w-4" />
				</Button>
			</SheetTrigger>
			<SheetContent>
				<SheetTitle className="sr-only">{t("mobile-menu.title")}</SheetTitle>
				<SheetDescription className="sr-only">
					{t("mobile-menu.description")}
				</SheetDescription>

				<div className="flex items-center justify-between border-b border-border px-4 py-3">
					<div className="flex items-center gap-3">
						<TenbaggerLogo />
						<span className="text-title1 text-white">
							tenbagger
						</span>
					</div>
					<SheetClose asChild>
						<Button
							variant="ghost"
							size="icon-sm"
							className="text-muted-foreground hover:text-foreground"
							aria-label={t("mobile-menu.close")}
						>
							<X className="h-4 w-4" />
						</Button>
					</SheetClose>
				</div>

				<nav className="flex flex-col gap-1 px-3 py-4">
					{NAV_LINKS.map((link) => (
						<LocalizedLink
							key={link.to}
							to={link.to}
							className={
								link.to === "/trade" && isTradeActive
									? menuItemActiveClass
									: menuItemClass
							}
							activeProps={{ className: menuItemActiveClass }}
							onClick={() => setOpen(false)}
						>
							{t(link.labelKey)}
						</LocalizedLink>
					))}
				</nav>

				<div className="border-t border-border px-4 py-3">
					<div className="flex items-center gap-1">
						<LanguageSwitcher />
						<ThemeToggle />
					</div>
				</div>
			</SheetContent>
		</Sheet>
	);
}
